<template>
<ItpPage
  no-primary-button
  :closeButtonText="'Close'|gettext"
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CreateMeter"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      schema="CreateMeter"
      :id="formId"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetMeterGeneralData
        :meter="item"
      >
      </FieldsetMeterGeneralData>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.create.isRunning"
      :disabled="!forms[formName] || !forms[formName].submittable"
    >
    </ItpButton>
    <ItpButton
      :text="'Save and create another'|pgettext('LetterRegisterEntry/Command')"
      :disabled="!forms[formName] || !forms[formName].submittable || actions.create && actions.create.isRunning"
      variant="light"
      icon="mdi:forward"
      class="mr-2"
      @click="evh_1419464017721962_click($event, {})"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.create.isRunning"
      @click.prevent.stop="evh_2186679009640457_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CreateMeter extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  item!: any;

  async $$load_item() {
    return this.$fn.schemaDefaults('CreateMeter', { multiplier: 1 })
  }

  formName!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  submitAndClose!: any;
  container!: any;

  async $$load_container() {
    return {
      self: this.$fn.urlFor('create_meter'),
      object: 'list',
      data: []
    }
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['item', 'formName', 'formId', 'submitAndClose', 'container', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        formName: "meter",
        formId: null,
        submitAndClose: true,
        container: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          noPrimaryButton: true,
          closeButtonText: this.$fn.gettext("Close"),
          size: "md",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.gettext("Create Meter"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4874_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4874, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_4880_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_4880, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1040167445267876_navigate_4882_getActionArgs($event: actions.ActionEvent): Promise<actions.NavigateActionArgs> {
    // parameterResolver name=act_1040167445267876_navigate_4882, alias=undefined
    return {
      location: {
        name: "app.meter",
        params: {
          id: $event.data.response.data.id,
        }
        ,
      }
      ,
    }
  }

  async act_1040167445267876_reloadSlickgrid_4884_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1040167445267876_reloadSlickgrid_4884, alias=undefined
    return {
      grid: "meters",
    }
  }

  async act_1040167445267876_rest_4878_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_1040167445267876_rest_4878, alias=create
    return {
      method: "save",
      container: this.container,
      resource: this.item,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_script_4888_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1419464017721962_script_4888, alias=undefined
    (
      this.setData('item', this.item.clone({
        id: null,
        rev: null,
        serial_number: null,
        links: null,
        etag: null,
        locked: null,
      })),
      this.setData('editor', this.item.editor())
    )
  }

  async act_1419464017721962_script_4888_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1419464017721962_script_4888, alias=undefined
    return {
      value: () => this.act_1419464017721962_script_4888_getActionArgs_value($event),
    }
  }

  async act_1419464017721962_reloadSlickgrid_4890_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1419464017721962_reloadSlickgrid_4890, alias=undefined
    return {
      grid: "meters",
    }
  }

  async act_1419464017721962_rest_4886_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_1419464017721962_rest_4886, alias=create2
    return {
      method: "save",
      container: this.container,
      resource: this.item,
    }
  }

  async evh_1419464017721962_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_click.executeFromDOM(this, event, scope);
  }

  async evh_2186679009640457_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4874: actions.CloseModalAction;
    evh_7315092382398562_close_4873: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_4876: actions.CloseComponentAction;
    evh_2248226175642056_close_4875: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_4880: actions.CloseModalAction;
    evh_1040167445267876_saved_4879: actions.EventHandlerImpl;
    act_1040167445267876_navigate_4882: actions.NavigateAction;
    evh_1040167445267876_saved_4881: actions.EventHandlerImpl;
    act_1040167445267876_reloadSlickgrid_4884: actions.ReloadSlickgridAction;
    evh_1040167445267876_saved_4883: actions.EventHandlerImpl;
    act_1040167445267876_rest_4878: actions.RestAction;
    evh_1040167445267876_submit_4877: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_script_4888: actions.ScriptAction;
    evh_1419464017721962_saved_4887: actions.EventHandlerImpl;
    act_1419464017721962_reloadSlickgrid_4890: actions.ReloadSlickgridAction;
    evh_1419464017721962_saved_4889: actions.EventHandlerImpl;
    act_1419464017721962_rest_4886: actions.RestAction;
    evh_1419464017721962_click_4885: actions.EventHandlerImpl;
    evh_1419464017721962_click: actions.EventHandlerGroup;
    act_2186679009640457_closeComponent_4892: actions.CloseComponentAction;
    evh_2186679009640457_clickPreventStop_4891: actions.EventHandlerImpl;
    evh_2186679009640457_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4874 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4874_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4873 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4874,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4873],
      }
    );
    const act_2248226175642056_closeComponent_4876 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_4875 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_4876,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_4875],
      }
    );
    const act_1040167445267876_closeModal_4880 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_4880_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_saved_4879 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_4880,
        event: "saved",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_navigate_4882 = new actions.NavigateAction(
      {
        actionArgs: this.act_1040167445267876_navigate_4882_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_saved_4881 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_navigate_4882,
        event: "saved",
        displayName: "navigate",
      }
    );
    const act_1040167445267876_reloadSlickgrid_4884 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1040167445267876_reloadSlickgrid_4884_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_saved_4883 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_reloadSlickgrid_4884,
        event: "saved",
        displayName: "reloadSlickgrid",
      }
    );
    const act_1040167445267876_rest_4878 = new actions.RestAction(
      {
        actionArgs: this.act_1040167445267876_rest_4878_getActionArgs,
        displayName: "create",
        events: [evh_1040167445267876_saved_4879, evh_1040167445267876_saved_4881, evh_1040167445267876_saved_4883],
      }
    );
    const evh_1040167445267876_submit_4877 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_rest_4878,
        event: "submit",
        displayName: "create",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_4877],
      }
    );
    const act_1419464017721962_script_4888 = new actions.ScriptAction(
      {
        actionArgs: this.act_1419464017721962_script_4888_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_saved_4887 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_script_4888,
        event: "saved",
        displayName: "script",
      }
    );
    const act_1419464017721962_reloadSlickgrid_4890 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1419464017721962_reloadSlickgrid_4890_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_saved_4889 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_reloadSlickgrid_4890,
        event: "saved",
        displayName: "reloadSlickgrid",
      }
    );
    const act_1419464017721962_rest_4886 = new actions.RestAction(
      {
        actionArgs: this.act_1419464017721962_rest_4886_getActionArgs,
        displayName: "create2",
        events: [evh_1419464017721962_saved_4887, evh_1419464017721962_saved_4889],
      }
    );
    const evh_1419464017721962_click_4885 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_rest_4886,
        event: "click",
        displayName: "create2",
      }
    );
    const evh_1419464017721962_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_click_4885],
      }
    );
    const act_2186679009640457_closeComponent_4892 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2186679009640457_clickPreventStop_4891 = new actions.EventHandlerImpl(
      {
        action: act_2186679009640457_closeComponent_4892,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_2186679009640457_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2186679009640457_clickPreventStop_4891],
      }
    );
    return {
      act_7315092382398562_closeModal_4874,
      evh_7315092382398562_close_4873,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_4876,
      evh_2248226175642056_close_4875,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_4880,
      evh_1040167445267876_saved_4879,
      act_1040167445267876_navigate_4882,
      evh_1040167445267876_saved_4881,
      act_1040167445267876_reloadSlickgrid_4884,
      evh_1040167445267876_saved_4883,
      act_1040167445267876_rest_4878,
      evh_1040167445267876_submit_4877,
      evh_1040167445267876_submit,
      act_1419464017721962_script_4888,
      evh_1419464017721962_saved_4887,
      act_1419464017721962_reloadSlickgrid_4890,
      evh_1419464017721962_saved_4889,
      act_1419464017721962_rest_4886,
      evh_1419464017721962_click_4885,
      evh_1419464017721962_click,
      act_2186679009640457_closeComponent_4892,
      evh_2186679009640457_clickPreventStop_4891,
      evh_2186679009640457_clickPreventStop,
      create: act_1040167445267876_rest_4878,
      create2: act_1419464017721962_rest_4886,
    }
  }
}

Vue.component("CreateMeter", CreateMeter);

</script>